import { hideLoader, showLoader } from "../Slices/loadingSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GlobalService, HttpService } from "../../modules";
import { CompanyFormData } from "../../modules/user/models";
import i18n from "../../i18n";
export const createAvaibility = createAsyncThunk<any, { data: any }>(
    "professionals/createAvaibility",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.post(
                "api/v1/user-availabilities/bulk",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());            
            // GlobalService.showToast("success", "Success", "User Availability Created Successfully");
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Availabilities created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const getUserAvailabilities = createAsyncThunk<any, any>(
    "professionals/getUserAvailabilities",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            // dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/user-availabilities/user/${id}`,

                true,
                {}
            );
            dispatch(hideLoader());
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Availabilities  failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const UpdateUserAvailabilities = createAsyncThunk<any, { id: string; data: any }>(
    "professionals/UpdateUserAvailabilities",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(
                `api/v1/user-availabilities/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());
            
            // GlobalService.showToast("success", "Success", "User availabilities Updated Successfully");
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update availabilities failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createSkills = createAsyncThunk<any, { data: any }>(
    "professionals/createSkills",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.post(
                "api/v1/user-skills/bulk",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());                        
            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.skills.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Skills created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const deleteUserSkills = createAsyncThunk<any, { id: string }>(
    "professionals/deleteUserSkills",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.deleteRecord(
                `api/v1/user-skills/${id}`,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.skills.deleted"));
            return { id };
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User deleted skills failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserSkills = createAsyncThunk<any, any>(
    "professionals/getUserSkills",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            // dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/user-skills/user/${id}`,

                true,
                {}
            );
            dispatch(hideLoader());
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Skills  failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getStaticSkills = createAsyncThunk<any, any>(
    "professionals/getStaticSkills",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.get(
                "api/v1/skills",

                true,
                {}
            );
            dispatch(hideLoader());
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Skills  failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createStaticSkill = createAsyncThunk<any,  any >(
    "professionals/createStaticSkill",
    async ({ name }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const dataSender={name};            
            const response = await HttpService.post(
                "api/v1/skills",
                dataSender,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());            
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Static Skills created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const UpdateUserSkills = createAsyncThunk<any, { id: string; data: any }>(
    "professionals/UpdateUserSkills",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(
                `api/v1/user-skills/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());
            
            // GlobalService.showToast("success", "Success", "User availabilities Updated Successfully");
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update skills failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const deleteUserAvailabilities = createAsyncThunk<any, { id: string }>(
    "professionals/deleteUserAvailabilities",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.deleteRecord(
                `api/v1/user-availabilities/${id}`,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.availabilities.deleted"));
            return { id };
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User deleted availabilities failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserCertificates = createAsyncThunk<any, any>(
    "professionals/getUserCertificates",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            // dispatch(showLoader());
            const response = await HttpService.get(`api/v1/certificates/user/${id}`, true, {});

            dispatch(hideLoader());            
            return response; // <<-- return only the "data" array
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Certificates failed";
            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createUserCertificate = createAsyncThunk<any, { data: any }>(
    "professionals/createUserCertificate",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.post(
                "api/v1/certificates/bulk",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.certificates.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Certificates created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const UpdateUserCertificate = createAsyncThunk<any, { id: string; data: any }>(
    "professionals/UpdateUserCertificate",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(
                `api/v1/certificates/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            // GlobalService.showToast("success", "Success", "User Certificates Updated Successfully");
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Certificates failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const deleteUserEducation = createAsyncThunk<any, { id: string }>(
    "professionals/deleteUserEducation",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.deleteRecord(
                `api/v1/education/${id}`,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.educations.deleted"));
            return { id };
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User deleted education failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserEducation = createAsyncThunk<any, any>(
    "professionals/getUserEducation",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            // dispatch(showLoader());
            const response = await HttpService.get(`api/v1/education/user/${id}`, true, {});
            dispatch(hideLoader());
            return response; // <<-- return only the "data" array
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Education failed";
            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createUserEducation = createAsyncThunk<any, { data: any }>(
    "professionals/createUserEducation",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/education/bulk",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.educations.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Education created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const deleteUserCertificate = createAsyncThunk<any, { id: string }>(
    "professionals/deleteUserCertificate",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.deleteRecord(
                `api/v1/certificates/${id}`,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.certificates.deleted"));
            return { id };
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User deleted certificates failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const UpdateUserEducation = createAsyncThunk<any, { id: string; data: any }>(
    "professionals/UpdateUserCertificate",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(
                `api/v1/education/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            // GlobalService.showToast("success", "Success", "User Education Updated Successfully");
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Education failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const deleteUserExperience = createAsyncThunk<any, { id: string }>(
    "professionals/deleteUserExperience",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.deleteRecord(
                `api/v1/experiences/${id}`,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.experiences.deleted"));
            return { id };
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User deleted experience failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserExperience = createAsyncThunk<any, any>(
    "professionals/getUserExperience",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            // dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/experiences/user/${id}`,

                true,
                {}
            );
            dispatch(hideLoader());
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User experiences  failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const UpdateUserExperience = createAsyncThunk<any, { id: string; data: any }>(
    "professionals/UpdateUserExperience",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(
                `api/v1/experiences/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            // GlobalService.showToast("success", "Success", "User Experiences Updated Successfully");
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Experiences failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createUserExperience = createAsyncThunk<any, { data: any }>(
    "professionals/createUserExperience",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.post(
                "api/v1/experiences/bulk",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.experiences.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Experience created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const deleteUserPortfolio = createAsyncThunk<any, { id: string }>(
    "professionals/deleteUserPortfolio",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.deleteRecord(
                `api/v1/portfolios/${id}`,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.portfolios.deleted"));
            return { id };
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User deleted portfolio failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserPortfolio = createAsyncThunk<any, any>(
    "professionals/getUserPortfolio",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            // dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/portfolios/user/${id}`,

                true,
                {}
            );
            dispatch(hideLoader());
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User portfolios  failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const UpdateUserPortfolio = createAsyncThunk<any, { id: string; data: any }>(
    "professionals/UpdateUserPortfolio",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(
                `api/v1/portfolios/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            // GlobalService.showToast("success", "Success", "User portfolios Updated Successfully");
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update portfolios failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createUserPortfolio = createAsyncThunk<any, { data: any }>(
    "professionals/createUserPortfolio",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/portfolios/bulk",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.portfolios.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User portfolios created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createGeneralSetting = createAsyncThunk<any, { data: any }>(
    "professionals/createGeneralSetting",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.post(
                "api/v1/general-settings",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.general.generalSettingsCreated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "General Settings created failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const UpdateGeneralSettings = createAsyncThunk<any, { id: string; data: any }>(
    "professionals/UpdateGeneralSettings",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(
                `api/v1/general-settings/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.general.generalSettingsUpdated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());

            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "General Settings Update failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const getProfessionalStats = createAsyncThunk<any, { id: string; isShowLoader?: boolean }>(
    "professional/getProfessionalStats",
    async ({ id, isShowLoader = true }, { dispatch, rejectWithValue }) => {
        try {
            if (isShowLoader) {
                dispatch(showLoader());
            }

            const response = await HttpService.get(
                `api/v1/users/professional-stats/${id}`,
                true,
                {}
            );

            if (isShowLoader) {
                dispatch(hideLoader());
            }

            if (typeof response == "string" && response.length == 0) {
                return null;
            } else {
                return response;
            }
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "Failed to fetch professional stats";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
